import { render, staticRenderFns } from "./app-header-global-search-empty.vue?vue&type=template&id=4f2ccf28&"
import script from "./app-header-global-search-empty.vue?vue&type=script&lang=ts&"
export * from "./app-header-global-search-empty.vue?vue&type=script&lang=ts&"
import style0 from "./app-header-global-search-empty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports